import { AxiosResponse, Canceler } from 'axios';
import { IBundlePackage, IApiResult } from '../types';
import settings from '../settings';
import api from './base';

export function fetchAllBundlePackages(): [Promise<AxiosResponse<{ [storyId: number]: IBundlePackage[] }>>, Canceler] {
  return api.getWithCancel(`${settings.getApiURI()}/story-admin/v1/episode-bundles`);
}

export function fetchBundlePackages(storyId: number): Promise<AxiosResponse<IBundlePackage[]>> {
  return api.http.get(`${settings.getApiURI()}/story-admin/v1/story/${storyId}/episode-bundles`);
}

export function deleteBundlePackage(storyId: number, bundleId: number): Promise<AxiosResponse<IApiResult<IBundlePackage>>> {
  return api.http.delete(`${settings.getApiURI()}/story-admin/v1/story/${storyId}/episode-bundles/${bundleId}`);
}

//{ showRemainAll, prices: bundles, minRemainEpisodesNumber, maxRemainEpisodesNumber } as
export function createOrUpdateBundlePackage(
  storyId: number,
  bundles: Partial<IBundlePackage>[],
): Promise<AxiosResponse<IApiResult<IBundlePackage[]>>> {
  const uri = `${settings.getApiURI()}/story-admin/v1/story/${storyId}/episode-bundles`;
  return api.http.patch(uri, bundles);
}
